import React, { Component } from 'react'
import styles from './sectionTitle.scss'

class SectionTitle extends Component {
  render() {
    return (
      <div className={styles['sectionTitle']}>
        <h2>
          {this.props.title}
        </h2>
      </div>
    )
  }
}

export default SectionTitle
